import { components } from '@pages/names';

export default (state = 'PAGE_HOME', action = {}) =>
  components[action.type] || state;
